const MODE_ORDER = ['LEGACY_ONLY', 'SHADOW_V2', 'V2_PRIMARY_WITH_LEGACY_FALLBACK', 'V2_ONLY'];

export const modeLabelMap = {
  LEGACY_ONLY: 'LEGACY ONLY',
  SHADOW_V2: 'SHADOW V2',
  V2_PRIMARY_WITH_LEGACY_FALLBACK: 'V2 PRIMARY + LEGACY FALLBACK',
  V2_ONLY: 'V2 ONLY',
};

export const readinessToneMap = {
  READY: 'text-emerald-200 bg-emerald-500/15 border-emerald-400/40',
  READY_WITH_CAUTION: 'text-amber-200 bg-amber-500/15 border-amber-400/40',
  BLOCKED: 'text-red-200 bg-red-500/15 border-red-400/40',
  ROLLBACK_RECOMMENDED: 'text-purple-200 bg-purple-500/15 border-purple-400/40',
};

export const checklistToneMap = {
  PASS: 'text-emerald-200 bg-emerald-500/15 border-emerald-400/40',
  WARNING: 'text-amber-200 bg-amber-500/15 border-amber-400/40',
  FAIL: 'text-red-200 bg-red-500/15 border-red-400/40',
};

export const toPercent = (value) => {
  const n = Number(value || 0);
  if (!Number.isFinite(n)) return '-';
  return `${Math.round(n * 10000) / 100}%`;
};

export const formatDatetime = (value) => {
  if (!value) return '-';
  const ts = Date.parse(value);
  if (Number.isNaN(ts)) return '-';
  return new Date(ts).toLocaleString('id-ID');
};

export const getNextRolloutMode = (currentMode) => {
  const key = String(currentMode || '').toUpperCase();
  const idx = MODE_ORDER.indexOf(key);
  if (idx < 0) return 'SHADOW_V2';
  return MODE_ORDER[Math.min(idx + 1, MODE_ORDER.length - 1)];
};

export const safeArray = (value) => (Array.isArray(value) ? value : []);

export const buildRiskMetrics = ({ readiness, shadowSummary, performance, mismatches }) => {
  const summaryMetrics = readiness?.summaryMetrics || {};
  const mismatchByCategory = mismatches?.mismatch_by_category || {};
  return {
    fallbackRate: Number(summaryMetrics.fallbackRate ?? shadowSummary?.fallback_rate ?? 0),
    v2ErrorRate: Number(summaryMetrics.v2ErrorRate ?? 0),
    criticalMismatchCount: Number(summaryMetrics.criticalMismatchCount ?? 0),
    expectedDivergenceRate: Number(summaryMetrics.expectedDivergenceRate ?? shadowSummary?.expected_divergence_rate ?? 0),
    flappingSuppressionCount: Number(summaryMetrics.flappingSuppressionCount ?? performance?.flapping_suppression_count ?? 0),
    cooldownDeferCount: Number(summaryMetrics.cooldownDeferCount ?? 0),
    mismatchByCategory,
  };
};

export const getValidationSummaryText = (validation) => {
  if (!validation) return 'Belum ada validasi mode.';
  if (validation.allowed) return 'Transisi valid, mode dapat diubah.';
  return 'Transisi tidak valid, review blocker sebelum lanjut.';
};
